import { createContext, useContext, useState } from 'react'

class Comments {
  constructor ({ commentSidebarOpenState, commentBlockIdState, commentPagePropertyState }) {
    const [commentSidebarOpen, setCommentSidebarOpen] = commentSidebarOpenState
    this.commentSidebarOpen = commentSidebarOpen

    const [commentBlockId, setCommentBlockId] = commentBlockIdState
    this.commentBlockId = commentBlockId

    const [commentPageProperty, setCommentPageProperty] = commentPagePropertyState
    this.commentPageProperty = commentPageProperty

    // Helper functions
    this.clearCommentContext = () => {
      setCommentBlockId(null)
      setCommentPageProperty(null)
    }

    this.closeCommentSidebar = (itemId = '') => {
      if (itemId) {
        localStorage.removeItem('comments-open-' + itemId)
      }
      setCommentSidebarOpen(false)
      this.clearCommentContext()
    }

    this.openCommentSidebar = (itemId = '') => {
      setCommentSidebarOpen(true)
      if (itemId) {
        localStorage.setItem('comments-open-' + itemId, new Date())
      }
    }

    this.openBlockComments = (id) => {
      this.clearCommentContext()
      this.openCommentSidebar()
      setCommentBlockId(id)
    }

    this.openPagePropertyComments = (type) => {
      this.clearCommentContext()
      this.openCommentSidebar()
      setCommentPageProperty(type)
    }
  }

  getCommentSidebarOpen () {
    return this.commentSidebarOpen
  }
}

const CommentContext = createContext()

export const useCommentContext = function () {
  return useContext(CommentContext)
}

export const CommentContextProvider = function ({ itemId, children }) {
  const commentSidebarOpenState = useState(!!localStorage.getItem('comments-open-' + itemId))
  const commentBlockIdState = useState(null)
  const commentPagePropertyState = useState(null)
  const commentData = new Comments({ commentSidebarOpenState, commentBlockIdState, commentPagePropertyState })

  return (
    <CommentContext.Provider value={commentData}>
      {children}
    </CommentContext.Provider>
  )
}
